<template>
  <SideMenu
    ref="sideMenu"
    :heading="$lang('product_page', 'delivery_information')"
    :side="'right'"
    @on-side-menu-close="$emit('onProductDeliveryInformationClose')"
  >
    <div class="bg-main h-full flex flex-col">
      <div class="md:px-24 px-16 pt-28 overflow-y-auto mb-80">
        <div
          class="wysiwyg wysiwyg--sm mb-24"
          v-html="deliveryInformationText"
        />
      </div>
    </div>
  </SideMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SideMenu, { type SideMenuInterface } from '~/components/navigation/SideMenu.vue';
import Product from '~/models/product';

export default defineComponent({
  components: {
    SideMenu,
  },
  props: {
    product: {
      type: Product,
      required: true,
    },
  },
  computed: {
    deliveryInformationText(): string {
      return this.$accessor('config', 'deliveryInformation');
    },
  },
  mounted() {
    this.toggleSideMenu();
  },
  methods: {
    toggleSideMenu() {
      const sideMenu = this.$refs.sideMenu as SideMenuInterface;
      sideMenu.openOverlay();
    },
  },
});
</script>
